import {
    Component,
    Input,
    EventEmitter,
    Output,
    HostListener,
    ElementRef,
} from '@angular/core';
import { Alert } from '../../../../core/models/watchlist/watclist-alert';

@Component({
    selector: 'app-alert-item',
    templateUrl: './alert-item.component.html',
})
export class AlertItemComponent {
    @HostListener('click', ['$event'])
    @Output()
    closeAlerts: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() alert: Alert;

    constructor(private el: ElementRef) {
        
    }

    public getAnalysisDate(AnalysisDate: number) {
        return new Date(AnalysisDate);
    }

    closeMenu() {
        return this.closeAlerts.emit();
    }

    removeClass(event: Event) {
        return;
    }
}
